export default __webpack_public_path__ + "static/media/connect-light.479beef5.png";